import React from 'react';
import classNames from 'classnames';
import Stamp from 'common/Stamp';
import ResponsiveThumbnail from 'common/ResponsiveThumbnail';
import playable from 'common/playable';
import { BucketLayout } from 'enums';

const Tile = ({
    clickHandler,
    content,
    featured,
    playerHref,
    layoutType,
    selected,
    userAuthenticatedForContent,
    liveLabel
}) => {
    const { id, description, duration, formattedSubtitle, imageHref, name, score, shortDate, status, time, type } = content;

    const tileClassName = classNames('collection_item', {
        'collection_item--one': (layoutType === BucketLayout.DEFAULT || layoutType === BucketLayout.DEFAULT_UNLIMITED ||
            ((layoutType === BucketLayout.TAPESTRY_LEFT || layoutType === BucketLayout.TAPESTRY_RIGHT) &&
                !featured)),
        'collection_item--three': layoutType === BucketLayout.COLLECTION,
        'collection_item--featured': featured
    });

    const metaDataClass = classNames('collection_item_meta', 'icon-font-after', {
        'icon-key-solid-after': !userAuthenticatedForContent
    });

    const playButtonClass = classNames('button-play', 'button-play--video', {
        'button-play--live': status === 'live'
    });

    const activeClass = classNames('collection__link', {
        'collection__link--active': selected
    });

    // TODO: the "isNew" property doesn't actually exist yet
    const newStamp = content.isNew ? <div className="new">NEW</div> : '';
    const descriptionEl = (featured && description) ? <p className="collection_item_desc">{description}</p> : '';

    const subtitleEl = formattedSubtitle ? <span>{formattedSubtitle}</span> : null;

    return (
        <article onClick={clickHandler} className={tileClassName} data-id={id} data-score={score}>
            <a data-route="false" className={activeClass} href={playerHref}>
                <figure className="collection_item_media">
                    {newStamp}
                    <div className="media-wrapper media-wrapper--16x9">
                        <ResponsiveThumbnail lazyload src={imageHref} sizes={'33vw'} alt={name} />
                        <div className={playButtonClass} />
                        <Stamp
                            tileType={type}
                            status={status}
                            duration={duration}
                            time={time}
                            shortDate={shortDate}
                            isTile
                            liveLabel={liveLabel}
                        />
                    </div>
                    <figcaption>
                        <h1 className="collection_item_title">{name}</h1>
                        <div className={metaDataClass}>
                            <div className="collection_item_truncate">
                                {subtitleEl}
                            </div>
                        </div>
                        {descriptionEl}
                    </figcaption>
                </figure>
            </a>
        </article>
    );
};

Tile.propTypes = {
    clickHandler: React.PropTypes.func,
    content: React.PropTypes.object,
    featured: React.PropTypes.bool,
    layoutType: React.PropTypes.string,
    playerHref: React.PropTypes.string,
    selected: React.PropTypes.bool,
    userAuthenticatedForContent: React.PropTypes.bool,
    liveLabel: React.PropTypes.string
};

export default playable(Tile);
export { Tile as BaseTile };



// WEBPACK FOOTER //
// ./app/page/buckets/Tile.js